var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8235 13.4972L9.80674 9.47756C10.5986 8.52787 11.0749 7.31423 11.0749 5.98868C11.0749 2.9646 8.59309 0.505741 5.54032 0.505741C2.48755 0.505741 0 2.96747 0 5.99155C0 9.01563 2.48181 11.4745 5.53458 11.4745C6.83144 11.4745 8.025 11.0298 8.97182 10.2867L13.003 14.3178C13.2382 14.5531 13.5883 14.5531 13.8235 14.3178C14.0588 14.0825 14.0588 13.7325 13.8235 13.4972ZM1.17635 5.99155C1.17635 3.6159 3.13311 1.68496 5.53458 1.68496C7.93606 1.68496 9.89282 3.6159 9.89282 5.99155C9.89282 8.3672 7.93606 10.2981 5.53458 10.2981C3.13311 10.2981 1.17635 8.36433 1.17635 5.99155Z",
    fill: "#304059"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlue);
export default __webpack_public_path__ + "static/media/search-blue.f4cdff0749a04864298be9bc96b8aa0f.svg";
export { ForwardRef as ReactComponent };